<template>
        <div
            class="modal inmodal"
            :id="idModal"
            tabindex="-1"
            role="dialog"
            v-focustrap
        >
            <div class="row">
                <div
                    class="modal-dialog modal-dialog-centered"
                    :class="[modalLargura, colMd, offset]"
                >
                    <div class="modal-content">
                        <div
                            id="modal-divTitle"
                            class="modal-title d-print-none"
                            :class="modalColor"
                        >
                            <h5 id="modal-h5Title">
                                <i :class="iconModal"></i>
                                {{ subtitulo }}
                            </h5>
                        </div>
                        <div class="modal-body overflow-auto" style="max-height: 800px">
                            <slot name="modalContent">
                                
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
export default {
    name: "BaseModal",
    props: {
        idModal: {
            type: String,
            default: "myModal",
        },
        modalLargura: {
            type: String,
            default: "modal-xl",
        },
        colMd: {
            type: String,
            default: "",
        },
        offset: {
            type: String,
            default: "",
        },
        modalColor: {
            type: String,
            default: "border-primary bg-success",
        },
        iconModal: {
            type: String,
            default: "fa fa-list-ul",
        },
        subtitulo: {
            type: String,
            default: "Informações",
        },
        visivel: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style>
    .modal {
        display: block !important; /* Força a exibição */
        z-index: 1050;
    }

    .modal-title {
      background-color: #ffffff;
      color: #ffffff;
      border-color: #e7eaec;
      border-image: none;
      border-style: solid solid none;
      border-width: 1px;
      margin-bottom: 0;
      padding: 15px 90px 8px 15px;
      min-height: 48px;
      position: relative;
      clear: both;
      -webkit-border-radius: 3px 3px 0 0;
      -moz-border-radius: 3px 3px 0 0;
      border-radius: 2px 2px 0 0;
}
</style>
